export const BRANDING = {
  appName: "SchoolCatch",
  tagline: "Schools. Catchments. Choices.",
  logoSrc: "/logo_monkey.png",
};
